import { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { SUPPORTED_LANGUAGES, RTL_LANGUAGES } from '../i18n/languages.js';
import { useTranslation } from '../i18n/I18nContext.jsx';
import NotFoundPage from '../pages/NotFoundPage.jsx';

/**
 * Layout wrapper for all /:lang/* routes.
 *
 * - Validates the :lang param against SUPPORTED_LANGUAGES.
 * - Sets <html lang="..." dir="..."> on every language change.
 * - Renders <Outlet /> for child routes.
 */
export default function LangLayout() {
  const { lang: urlLang } = useParams();
  const { lang } = useTranslation();

  // Keep <html> attributes in sync with the active language.
  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = RTL_LANGUAGES.includes(lang) ? 'rtl' : 'ltr';
  }, [lang]);

  // Invalid language slug → 404
  if (!urlLang || !SUPPORTED_LANGUAGES.includes(urlLang)) {
    return <NotFoundPage />;
  }

  return <Outlet />;
}
